import React from 'react'
import { LinkIndeedFlexLocationButton } from './LinkIndeedFlexLocationButton'
import { LinkIndeedFlexPositionButton } from './LinkIndeedFlexPositionButton'
import { CreateIndeedFlexShiftButton } from './CreateIndeedFlexShiftButton'
import { CreateIndeedFlexPastShiftButton } from './CreateIndeedFlexPastShiftButton'
import { CreateIndeedFlexLongTermAssignmentButton } from './CreateIndeedFlexLongTermAssignmentButton'

const POSITION_NOT_MAPPED_ISSUE = 'position_not_mapped'
const LOCATION_NOT_MAPPED_ISSUE = 'location_not_mapped'

export type IndeedFlexShiftIssueActionItem = {
  ifClientId: number
  clientName: string
  ifShiftId: number
  ifJobId: number
  ifRoleId: number
  ifVenueId: number
  roleName: string | null
  venueName: string
  timezone: string
  startTime: string
  endTime: string
  allocationWithoutBuffer: number
  workShiftId: number | null
  issues: string[]
}

type IndeedFlexShiftIssueActionsProps = {
  shift: IndeedFlexShiftIssueActionItem
}

export const IndeedFlexShiftIssueActions = ({
  shift,
}: IndeedFlexShiftIssueActionsProps) => {
  const hasPositionNotMapped = shift.issues.includes(POSITION_NOT_MAPPED_ISSUE)
  const hasLocationNotMapped = shift.issues.includes(LOCATION_NOT_MAPPED_ISSUE)

  const canCreate =
    shift.workShiftId === null &&
    shift.issues.length === 1 &&
    !hasPositionNotMapped &&
    !hasLocationNotMapped &&
    (shift.issues[0] === 'not_processed' ||
      shift.issues[0] === 'failed_to_create')
  const isPastShift = new Date(shift.startTime) < new Date()

  if (!canCreate && !hasPositionNotMapped && !hasLocationNotMapped) {
    return null
  }

  return (
    <>
      {canCreate && !isPastShift ? (
        <>
          <CreateIndeedFlexShiftButton
            ifClientId={shift.ifClientId}
            ifShiftId={shift.ifShiftId}
          />
          <CreateIndeedFlexLongTermAssignmentButton
            ifClientId={shift.ifClientId}
            ifJobId={shift.ifJobId}
          />
        </>
      ) : null}
      {canCreate && isPastShift ? (
        <CreateIndeedFlexPastShiftButton
          ifClientId={shift.ifClientId}
          ifShiftId={shift.ifShiftId}
          allocationWithoutBuffer={shift.allocationWithoutBuffer}
          startTime={shift.startTime}
          endTime={shift.endTime}
          timezone={shift.timezone}
        />
      ) : null}
      {hasPositionNotMapped ? (
        <LinkIndeedFlexPositionButton
          ifClientId={shift.ifClientId}
          ifRoleId={shift.ifRoleId}
          roleName={shift.roleName ?? ''}
          clientName={shift.clientName}
        />
      ) : null}
      {hasLocationNotMapped ? (
        <LinkIndeedFlexLocationButton
          ifClientId={shift.ifClientId}
          ifVenueId={shift.ifVenueId}
          venueName={shift.venueName}
          clientName={shift.clientName}
        />
      ) : null}
    </>
  )
}
